<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
    	<path fill="#FFF" fill-rule="evenodd" d="M16.155 10.946c-.72 0-1.303-.567-1.303-1.268 0-.7.583-1.266 1.303-1.266s1.304.567 1.304 1.266c0 .7-.583 1.268-1.304 1.268m-5.22-.166c-.73 0-1.324-.575-1.324-1.287 0-.709.593-1.284 1.325-1.284.73 0 1.323.575 1.323 1.284 0 .712-.593 1.287-1.323 1.287m-5.22.163c-.72 0-1.303-.567-1.303-1.268 0-.698.583-1.266 1.303-1.266s1.304.568 1.304 1.266c0 .701-.585 1.268-1.304 1.268M0 9.47c0 2.917.793 5.279 3.32 6.972l-1.258 3.979c-.18.412.366.905.775.704l5.559-2.576c.743.149 1.604.393 2.54.393 6.48 0 10.934-4.177 10.934-9.472S17.417 0 10.936 0C4.455 0 0 4.176 0 9.471z"/>
	</svg>
</template>
<script>
export default { name: 'header-message-icon' }
</script>
